import React, { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import { IBtnCompany } from '../../../common/interfaces/company.interfaces';
import '../style.css';

const BtnCompany : React.FC<IBtnCompany> = (dados) => {
const [classBtn, setClassBtn] = useState("shadow btn " + `${dados.className}`);

    return(<>
    <Link to={dados.path}>
        <button className={classBtn}>
        <img src={dados.src} className="p-3"/>
            <p className="p-1 teste">
                Acesse
                <BsArrowRight className="ml-2"/>
            </p>  
        </button>
    </Link>
    </>)
};

export default BtnCompany;
